{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/gallery",
	"title": "Gallery",
	"category": "media",
	"usesContext": [ "galleryId", "postId", "postType" ],
	"allowedBlocks": [ "core/image" ],
	"description": "Display multiple images in a rich gallery.",
	"keywords": [ "images", "photos" ],
	"textdomain": "default",
	"attributes": {
		"images": {
			"type": "array",
			"default": [],
			"source": "query",
			"selector": ".blocks-gallery-item",
			"query": {
				"url": {
					"type": "string",
					"source": "attribute",
					"selector": "img",
					"attribute": "src"
				},
				"fullUrl": {
					"type": "string",
					"source": "attribute",
					"selector": "img",
					"attribute": "data-full-url"
				},
				"link": {
					"type": "string",
					"source": "attribute",
					"selector": "img",
					"attribute": "data-link"
				},
				"alt": {
					"type": "string",
					"source": "attribute",
					"selector": "img",
					"attribute": "alt",
					"default": ""
				},
				"id": {
					"type": "string",
					"source": "attribute",
					"selector": "img",
					"attribute": "data-id"
				},
				"caption": {
					"type": "rich-text",
					"source": "rich-text",
					"selector": ".blocks-gallery-item__caption"
				}
			}
		},
		"ids": {
			"type": "array",
			"items": {
				"type": "number"
			},
			"default": []
		},
		"dynamicContent": {
			"type": "object"
		},
		"navigationButtonType": {
			"type": "string",
			"default": "icon",
			"enum": [ "icon", "text", "both" ]
		},
		"shortCodeTransforms": {
			"type": "array",
			"items": {
				"type": "object"
			},
			"default": []
		},
		"columns": {
			"type": "number",
			"minimum": 1,
			"maximum": 8
		},
		"caption": {
			"type": "rich-text",
			"source": "rich-text",
			"selector": ".blocks-gallery-caption",
			"role": "content"
		},
		"imageCrop": {
			"type": "boolean",
			"default": true
		},
		"randomOrder": {
			"type": "boolean",
			"default": false
		},
		"fixedHeight": {
			"type": "boolean",
			"default": true
		},
		"linkTarget": {
			"type": "string"
		},
		"linkTo": {
			"type": "string"
		},
		"sizeSlug": {
			"type": "string",
			"default": "large"
		},
		"allowResize": {
			"type": "boolean",
			"default": false
		},
		"aspectRatio": {
			"type": "string",
			"default": "auto"
		}
	},
	"providesContext": {
		"allowResize": "allowResize",
		"imageCrop": "imageCrop",
		"fixedHeight": "fixedHeight",
		"navigationButtonType": "navigationButtonType"
	},
	"supports": {
		"anchor": true,
		"align": true,
		"__experimentalBorder": {
			"radius": true,
			"color": true,
			"width": true,
			"style": true,
			"__experimentalDefaultControls": {
				"color": true,
				"radius": true
			}
		},
		"html": false,
		"units": [ "px", "em", "rem", "vh", "vw" ],
		"spacing": {
			"margin": true,
			"padding": true,
			"blockGap": {
				"sides": [ "horizontal", "vertical" ],
				"__experimentalDefault": "var( --wp--style--gallery-gap-default, var( --gallery-block--gutter-size, var( --wp--style--block-gap, 0.5em ) ) )"
			},
			"__experimentalDefaultControls": {
				"blockGap": true,
				"margin": false,
				"padding": false
			}
		},
		"color": {
			"text": false,
			"background": true,
			"gradients": true
		},
		"layout": {
			"allowSwitching": false,
			"allowInheriting": false,
			"allowEditing": false,
			"default": {
				"type": "flex"
			}
		},
		"interactivity": {
			"clientNavigation": true
		},
		"listView": true
	},
	"editorStyle": "wp-block-gallery-editor",
	"style": "wp-block-gallery"
}
